<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="250px"
      @submit.prevent="onSubmit"
      style="margin:20px;width:60%;min-width:600px;"
    >
      <el-form-item label="Zone Name">
        <el-input v-model="form.lowLimit" type="number" step="1"></el-input>
      </el-form-item>
      <el-form-item label="Panel ID">
        <el-input v-model="form.highLimit" type="number"></el-input>
      </el-form-item>
      <el-form-item style="margin-top:10px">
        <el-button type="primary" style="margin-top:10px" @click="addZone">Add</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import Axios from 'axios';



export default {
  data() {
    return {
      loading: false,
      form: {
        zoneName: '',
        panelID: ''
      },
      user: this.$session.get('User')
    }
  },
  mounted() {
  },
  methods: {
    saveDataToPanel() {
      this.loading = true;
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, 'Settings.Motor.Limit.Low', this.form.lowLimit),

      ]).then(Axios.spread((lowLimitResponse, highLimitResponse, valveSetSpeedResponse) => {
        //The system should update in 10 seconds.
        this.loading = false;
        if (lowLimitResponse.data.result != "success" ||
          highLimitResponse.data.result != "success" ||
          valveSetSpeedResponse.data.result != "success") {
          const h = this.$createElement;
          this.$notify({
            title: 'Motor Settings',
            message: 'Error trying to save data to panel',
            type: 'error'
          });
        } else {
          this.$notify({
            title: 'Motor',
            message: 'Settings Saved to Panel',
            type: 'info'
          });
        }
      })).catch(() => {
        this.loading = false;
        const h = this.$createElement;
        this.$notify({
          title: 'Motor Settings',
          message: 'Error trying to save data to panel',
          type: 'error'
        });
      });
    }
  }
}

</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>


// WEBPACK FOOTER //
// AddZone.vue?3ef3602c